import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { supportedVendorsSchema } from '@eluve/graphql-types';

const c = initContract();

export const locationsContract = c.router(
  {
    getLocations: {
      method: 'GET',
      path: '/',
      responses: {
        200: z.object({
          locations: z.array(
            z.object({
              id: z.string(),
              name: z.string(),
            }),
          ),
        }),
      },
      summary: 'Get available tenant locations',
    },
    getEhrOnboardingStatus: {
      method: 'GET',
      path: '/ehr-onboarding-status',
      responses: {
        200: z.object({
          isUserPartOfAnyLocation: z.boolean(),
          areLocationsAvailable: z.boolean(),
          hasEhrEnabled: z.boolean(),
          hasWebBasedEhr: z.boolean(),
          hasSyncedBefore: z.boolean(),
          didUserFinishOnboarding: z.boolean(),
          shouldPromptOnboarding: z.boolean(),
          isExtensionRequired: z.boolean(),
          externalEhrs: z.array(
            z.object({
              id: z.string(),
              vendor: supportedVendorsSchema,
              domain: z.string(),
            }),
          ),
          locations: z.array(
            z.object({
              id: z.string(),
              name: z.string(),
            }),
          ),
        }),
      },
      summary:
        'Get EHR onboarding status for the current user. Not restricted by location membership.',
    },
    addUserToLocation: {
      method: 'POST',
      path: '/:locationId/users',
      responses: {
        201: z.object({}),
      },
      body: z.object({}),
      summary: 'Adds user to a location',
    },
    backfillLocationAttribution: {
      method: 'POST',
      path: '/attribution-backfill',
      responses: {
        201: z.object({}),
        409: z.object({ message: z.string() }),
      },
      body: z.object({
        externalEhrId: z.string().uuid(),
      }),
      summary:
        'Queue a job that re-attributes all users and recent appointments to locations from EMR sync data. Eluve admins only; one run per tenant + EHR at a time.',
    },
    addEhr: {
      method: 'POST',
      path: '/:locationId/ehr',
      responses: {
        201: z.object({
          externalEhrId: z.string(),
        }),
      },
      body: z.object({
        vendor: supportedVendorsSchema,
        domain: z.string(),
        vendorConfiguration: z
          .object({
            plainTextConfig: z.record(z.string()).optional(),
            secretConfig: z.record(z.string()).optional(),
          })
          .optional(),
      }),
      summary: 'Add EHR to a location',
    },
  },
  {
    pathPrefix: '/:tenantId/locations',
  },
);
